import * as _ from 'lodash';

import * as ALARMS from './alarms.constants';
import ReducerCreator from '../registerReducer';
import { StoreItem, DispatchEvent } from '../Store';
import { AlarmList, Alarm } from '../../models/';
import { APPLICATION_DISCONNECTED } from '../application/application.constants';
import { copyStoreItem } from '../storeItemBuilder';


const r = new ReducerCreator<Alarm[]>()
    .register<string>(APPLICATION_DISCONNECTED, (state, payload) => {
        return new StoreItem<Alarm[]>();
    })
    .registers<any>([ALARMS.ALARM_LOAD, ALARMS.ALARMS_LOAD], (state, payload) => {
        return {
            dictionary: {},
            isLoading: true,
            isLoaded: false,
            hasError: false,
            error: null
        };
    })
    .registers<AlarmList>([ALARMS.ALARM_LOAD_SUCCESS, ALARMS.ALARMS_LOAD_SUCCESS], (state, payload) => {
        return buildAlarmsStoreItem(payload);
    })
    .registers<any>([ALARMS.ALARM_LOAD_ERROR, ALARMS.ALARMS_LOAD_ERROR], (state, reason) => {
        return {
            dictionary: {},
            isLoading: false,
            isLoaded: false,
            hasError: true,
            error: reason.data.Message || reason.message
        };
    })
    .registers<AlarmList>([
        ALARMS.ALARM_ADD_SUCCESS, ALARMS.ALARMS_ADD_SUCCESS, ALARMS.ALARM_UPDATE_SUCCESS, ALARMS.ALARMS_UPDATE_SUCCESS
    ], (state, payload) => {
        const newState = copyStoreItem(state.dictionary);
        Object.keys(payload).forEach(k => newState.dictionary[k] = payload[k]);
        return newState;
    })
    .registers<AlarmList>([ALARMS.ALARM_DELETE_SUCCESS, ALARMS.ALARMS_DELETE_SUCCESS], (state, payload) => {
        const newState = copyStoreItem(state.dictionary);
        Object.keys(payload).forEach(k =>
            newState.dictionary[k] = newState.dictionary[k].filter(e => payload[k].indexOf(e) < 0)
        );
        return newState;
    });

export function alarmsReducer(
    state: StoreItem<Alarm[]> = new StoreItem<Alarm[]>(),
    action: DispatchEvent<any>
) {
    return r.reduce(state, action);
}

function buildAlarmsStoreItem(payload: AlarmList): StoreItem<Alarm[]> {
    const dic = {};
    const keys = Object.keys(payload);
    keys.forEach(k => dic[k] = payload[k]);
    return {
        dictionary: dic,
        isLoading: false,
        isLoaded: true,
        hasError: false,
        error: null
    };
}